import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ActionButton from '../../components/Button/ActionButton';
import { ButtonCommonTopNew } from "../Theme";
import '../../styles/addpost.styles.scss'
import Swal from "sweetalert2";
import { serverUrl } from '../../components/Helpers/Config';
import { staticFiles } from "../../components/Helpers/Static";
import MarkDownContent from "./MarkDownContent";
import { tokenAuthorize } from "../../components/Helpers/Common";
import { getReflectionFeedbackProcessing } from "../../redux/actions/reflectionFeedback";
import { BiLeftArrowAlt } from "react-icons/bi"
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { GET_THEME_LOADER } from "../../redux/actions/auth";
const ViewPastReviews = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const urlParams = useParams();
    const [isLoading, setLoading] = useState(false);
    const [feedbackHistory, setFeedbackHistory] = useState([]);
    const [downloadText, setDownloadText] = useState('Download PDF');

    useEffect(() => {
        // setLoading(true);
        // localStorage.setItem('themeLoader', true);
        dispatch({ type: GET_THEME_LOADER, payload: true });
        dispatch(getReflectionFeedbackProcessing(false))
        axios.get(
            serverUrl.ReflectionFeedBackHistory + '/' + urlParams.postId
        ).then(resp => {
            if (resp.status === 200) {
                dispatch({ type: GET_THEME_LOADER, payload: false });
                //localStorage.setItem('themeLoader', false);
                // setLoading(false);
                setFeedbackHistory(resp.data.results);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            history.goBack();
            // setLoading(false);
            dispatch({ type: GET_THEME_LOADER, payload: false });
            //localStorage.setItem('themeLoader', false);
        })
    }, []);
    const handleDownloadPDF = async () => {
        try {
            setDownloadText('Processing...');
            const response = await axios.get(`${serverUrl.ExportReflectionFeedBackHistory + '/' + urlParams.postId}`, {
                headers: { "Content-Type": "multipart/form-data" },
                responseType: "blob"
            });
            if (response.status === 200) {
                setDownloadText('Download PDF');
                // Extract Content-Disposition header
                const contentDisposition = response.headers && response.headers['content-disposition'] || response.headers['Content-Disposition'];;
                // Default filename
                let filename = 'post.pdf';
                // Extract filename from Content-Disposition
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        filename = match[1].replace(/['"]/g, ''); // Remove quotes if present
                    }
                }
                // Create Blob and trigger download
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            } else {
                setDownloadText('Download PDF');
                Swal.fire({
                    title: "Info",
                    text: "No data found",
                    icon: "info",
                });
            }
        } catch (err) {
            setDownloadText('Download PDF');
            console.error("Error:", err);
            Swal.fire({
                title: "Info",
                text: "No data found",
                icon: "info",
            });
        }
    };
    const scrollToElement = (id) => {
        const element = document.getElementById('scroll' + id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    if (isLoading) return (
        <div className='w-full flex justify-center'>
            <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
        </div>
    )
    else return (
        <div className='px-6 py-4'>
            <div className='flex gap-2 w-full flex-wrap sm:flex-nowrap'>
                <div className='flex flex-col'>
                    <div className='w-full text-blue-500 font-semibold mb-2 flex justify-between'>
                        {/* <ActiveIconColor className='flex items-center w-max cursor-pointer' onClick={history.goBack}>
                            <AiOutlineLeft className='w-10 h-10' />
                            <h1 className='text-3xl'>
                                Back
                            </h1>
                        </ActiveIconColor> */}

                        <div
                            className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                            onClick={history.goBack}
                        >
                            <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
                            <h1 className="text-lg blueColor font-semibold">Back</h1>
                        </div>
                    </div>
                    <div className='w-full'>
                        <ActionButton className={"px-2 py-2.5 h-10 text-sm"} title={downloadText} style="px-8 py-4 sm:w-full" width="full" onClick={handleDownloadPDF} />
                        <div className="text-sm py-3">
                            <label className="font-bold whitespace-nowrap">View past feedback(s):</label>
                            <ol className="py-2 whitespace-nowrap px-3">
                                {feedbackHistory && feedbackHistory.map((i, index) => (
                                    <li className='cursor-pointer hover:underline' onClick={() => scrollToElement(index + 1)}>{index + 1}. {i.created_at}</li>
                                ))}
                                {/* <li>1. 20 Sept, 2025 10:10 AM</li>
                                <li>2. 22 Sept, 2025 12:50 PM</li>
                                <li>3. 24 Sept, 2025 01:30 AM</li> */}
                            </ol>
                        </div>
                    </div>
                </div>
                <div className="bg-white flex flex-col px-3 h-70 overflow-auto viewPastHistory">
                    {feedbackHistory && feedbackHistory.map((i, index) => (<>
                        <div id={'scroll' + (index + 1)}>
                            <h1 className={`font-bold text-xl mt-3`}>Feedback {index + 1} ({i.created_at})</h1>
                            <h1 className='font-bold my-3'>Reflection:</h1>
                            <p className="align-justify">
                                <MarkDownContent  htmlContent={i.reflection_text} className={false} />
                            </p>
                            <h1 className='font-bold my-3'>Feedback:</h1>
                            <MarkDownContent htmlContent={i.feedback_text} className={false} tableHeader={true} />
                            {feedbackHistory.length - 1 !== index ? <hr className='font-semibold mb-2 mt-2' /> : <></>}
                        </div>
                    </>
                    ))}
                </div>
            </div>
        </div >
    )
};

export default ViewPastReviews;
